import React from 'react';

function PublicLock({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" {...props}>
            <path
                fill={color}
                fillRule="evenodd"
                d="M1.5 9c0-4.14 3.36-7.5 7.5-7.5a7.505 7.505 0 0 1 7.403 6.29c-.447-.31-1.027-.515-1.685-.608a6.028 6.028 0 0 0-3.468-3.74v.308c0 .825-.675 1.5-1.5 1.5h-1.5v1.5c0 .412-.338.75-.75.75H6V9h4.464a2.185 2.185 0 0 0-.071.563v1.572c-1.018 0-1.393.678-1.393 1.24V16.5c-4.14 0-7.5-3.36-7.5-7.5ZM3 9c0 3.06 2.287 5.58 5.25 5.947V13.5c-.825 0-1.5-.675-1.5-1.5v-.75L3.158 7.657A6.088 6.088 0 0 0 3 9Z"
                clipRule="evenodd"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M16.286 11.85V10.5c0-1.26-1.061-2.25-2.411-2.25s-2.41.99-2.41 2.25v1.35c-.483 0-.965.45-.965.9v3.6c0 .45.482.9.964.9h4.822c.482 0 .964-.45.964-.9v-3.6c0-.45-.482-.9-.964-.9Zm-.965 0h-2.893V10.5c0-.72.675-1.35 1.447-1.35.771 0 1.446.63 1.446 1.35v1.35Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default React.memo(PublicLock);
